import {NinchatProperties} from '../../api/types'
import React from 'react'
import {SendNotesProps} from './types'
import SendNotesView from './SendNotesView'
import {useAppSelector} from '../../hooks'
import {useQueues} from '../../hooks/ninchat'

const SendNotes = (props: SendNotesProps): React.ReactElement => {
    const {
        chat,
        onSaveNotes,
        savedNotes,
    } = props

    const queueId = useAppSelector(({ninchat}) => {
        if (!chat.channel_id) {
            return ''
        }
        return ninchat.user_channels[chat.channel_id]?.channel_attrs?.queue_id ?? ''
    })

    const noteSettings = useAppSelector(({ninchat}): NinchatProperties.NinchatQueueNote[] => {
        if (!chat.channel_id) {
            return []
        }

        return ninchat.user_queues?.[queueId]?.queue_settings?.notes ?? []
    })

    const onSave = (notes: Record<string, unknown>): void => {
        const finalNotes: NinchatProperties.ChannelMetadataNote[] = noteSettings
            .filter((note) => note.name in notes) // Get only items from notes queue setting submitted in form
            .map((note) => (({
                label,
                name,
            }) => ( // Pick label and name from notes queue setting, and apply value from form
                {
                    label,
                    name,
                    value: notes[note.name],
                }))(note)) as NinchatProperties.ChannelMetadataNote[]

        onSaveNotes(finalNotes)
    }

    useQueues([queueId])

    return (
        <SendNotesView notes={noteSettings} onSave={onSave} savedNotes={savedNotes || []} />
    )
}

export default SendNotes
